import { FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { LoadPreviewErrorCode } from '../../compoundManagement/compoundManagement.types';
import { TransportAssignmentBulkUpdatePreviewErrorCode } from '../../transportAssignment/transportAssignment.types';

type BulkStatusVehicleErrorMessageProps = {
    errors: {
        errorCode: LoadPreviewErrorCode | TransportAssignmentBulkUpdatePreviewErrorCode;
        identifiers: string[];
        identifierType: 'VEHICLE' | 'ORDER';
    }[];
};

const getTranslationSource = (identifierType: 'VEHICLE' | 'ORDER') =>
    identifierType === 'VEHICLE'
        ? 'outboundOrderBook.compoundManagement.bulkStatusUpdate.unableToAddVehicles'
        : 'outboundOrderBook.transportAssignments.bulkUpdate.unableToUpdateAssignment';

export const BulkStatusErrorMessage: FunctionComponent<BulkStatusVehicleErrorMessageProps> = ({ errors }) => (
    <div className="alert alert-danger width-100pct space-y-10">
        {errors.map((error) => (
            <div className="display-flex gap-10" key={`${error.identifiers[0]} ${error.errorCode}`}>
                <span className="text-color-danger text-size-h4 rioglyph rioglyph rioglyph-error-sign" />
                <div>
                    <strong className="text-size-16">
                        <FormattedMessage
                            id={getTranslationSource(error.identifierType)}
                            values={{ count: error.identifiers.length }}
                        />{' '}
                        <FormattedMessage id="outboundOrderBook.bulkStatusUpdate.error.reason" />{' '}
                        <FormattedMessage id={`outboundOrderBook.bulkStatusUpdate.error.${error.errorCode}`} />
                    </strong>{' '}
                    <FormattedMessage id="outboundOrderBook.bulkStatusUpdate.error.automaticallyExcluded" />{' '}
                    {error.identifiers.join(', ')}
                </div>
            </div>
        ))}
    </div>
);
